module.exports = __webpack_public_path__ + "img/button-core.b2ad3e69.jpg";